module.exports = __webpack_public_path__ + "img/monitoring-tow-green.e58f01bb.svg";